var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/icon_sort_filter.eaa8a41f.png","uri@3x": __webpack_public_path__ + "static/media/icon_sort_filter.205009b1.png","uri@2x": __webpack_public_path__ + "static/media/icon_sort_filter.54f0f83a.png",
    width: 14,
    height: 10
});